import React from "react";


function Services() {
    return (
        <>
            <section className="page-section" id="services">
                <div className="container px-4 px-lg-5">
                    <h2 className="text-center mt-0">Ne iş yaparım</h2>
                    <hr className="divider"/>
                    <div className="row gx-4 gx-lg-5">
                        <div className="col-lg-3 col-md-6 text-center">
                            <div className="mt-5">
                                <div className="mb-2"><i className="bi-gem fs-1 text-primary"></i></div>
                                <h3 className="h4 mb-2">Mobil Uygulama</h3>
                                <p className="text-muted mb-0"> iOS ve Android için hızlı, kullanıcı dostu ve modern uygulamalar geliştiriyoruz.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 text-center">
                            <div className="mt-5">
                                <div className="mb-2"><i className="bi-laptop fs-1 text-primary"></i></div>
                                <h3 className="h4 mb-2">Web Sitesi Tasarım</h3>
                                <p className="text-muted mb-0">Markanızı en iyi şekilde yansıtan, modern ve her cihazda uyumlu web siteleri hazırlıyoruz.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 text-center">
                            <div className="mt-5">
                                <div className="mb-2"><i className="bi-globe fs-1 text-primary"></i></div>
                                <h3 className="h4 mb-2">E-Ticaret Alt Yapı</h3>
                                <p className="text-muted mb-0">Satışlarınızı artıracak güvenli ve ölçeklenebilir e-ticaret sistemleri kuruyoruz.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 text-center">
                            <div className="mt-5">
                                <div className="mb-2"><i className="bi-heart fs-1 text-primary"></i></div>
                                <h3 className="h4 mb-2">Yapay Zeka</h3>
                                <p className="text-muted mb-0">İş süreçlerinizi optimize eden akıllı AI çözümleri sunuyoruz.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Services;